import HistoryTables from './HistoryTables';

export default HistoryTables;
